var modules_6049fac5 = {"userInfo":"DesktopUserBlock_module_userInfo__3d0a7a87","dropdownWrapper":"DesktopUserBlock_module_dropdownWrapper__3d0a7a87","dropdown":"DesktopUserBlock_module_dropdown__3d0a7a87","dropdownArrow":"DesktopUserBlock_module_dropdownArrow__3d0a7a87","userName":"DesktopUserBlock_module_userName__3d0a7a87"};
import "../../../assets/esm/components/DesktopUserBlock/src/DesktopUserBlock~pxDAOOef.css";

export { modules_6049fac5 as default };
//# sourceMappingURL=DesktopUserBlock.module.less.js.map
